import { __decorate } from "tslib";
import { AsnProp, AsnPropTypes } from "@peculiar/asn1-schema";
import { HashAlgAndValue } from "./hash_alg_and_value";
export class LogotypeDetails {
    constructor(params = {}) {
        this.mediaType = "";
        this.logotypeHash = [];
        this.logotypeURI = [];
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: AsnPropTypes.IA5String })
], LogotypeDetails.prototype, "mediaType", void 0);
__decorate([
    AsnProp({ type: HashAlgAndValue, repeated: "sequence" })
], LogotypeDetails.prototype, "logotypeHash", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.IA5String, repeated: "sequence" })
], LogotypeDetails.prototype, "logotypeURI", void 0);
